import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './LandingPage.module.css';

const FAQS = [
  {
    q: '無料で始められますか？',
    a: '初期費用・月額費用は一切かかりません。チケット販売時のみ手数料が発生します。',
  },
  {
    q: '手数料はいくらですか？',
    a: (
      <>
        チケット販売時の手数料は「最大7%（システム利用料＋決済手数料）」です。<br />
        <b>主催者負担の場合：</b> 購入者はチケット価格のみ支払い、主催者の売上から最大7%（システム3%＋決済手数料3.6%前後）が差し引かれます。<br />
        <b>購入者負担の場合：</b> 購入者が「チケット価格＋7%」を支払います。<br />
        ※決済手数料はStripeの実績値により若干変動します。<br />
        投げ銭は受取額の15%がプラットフォーム手数料となります。
      </>
    ),
  },
  {
    q: 'チケットの入金はいつですか？',
    a: 'イベント終了後7日後を目安に、Stripe Connectアカウントへ売上送金処理を行います。 その後の銀行口座への入金タイミングは、Stripe側の入金スケジュール設定にてご指定いただけます。',
  },
  {
    q: '音楽以外のイベントも使えますか？',
    a: 'もちろんです。トークイベント、ワークショップ、スポーツ観戦など様々なイベントに対応しています。',
  },
  {
    q: '投げ銭機能はいつから使えますか？',
    a: 'イベント作成時に投げ銭を有効化するだけで、イベント終了後もファンから直接応援を受け取れます。',
  },
];

const FEATURES = [
  {
    icon: <img src="/icons/ticket.svg" alt="かんたんチケット販売" style={{width: '1.2em', height: '1.2em'}} />,
    title: 'かんたんチケット販売',
    desc: '価格タイプ・販売期間を自由に設定。無料チケットから複数価格帯まで柔軟に対応します。',
  },
  {
    icon: '📸',
    title: 'フォトギャラリー',
    desc: 'イベント後も盛り上がりを継続。主催者・参加者どちらからも思い出写真をアップロードできます。',
  },
  {
    icon: '💝',
    title: '投げ銭（チップ）',
    desc: '終演後もファンから直接応援を受け取れる投げ銭機能。イベントの追加収益チャンネルに。',
  },
  {
    icon: '📊',
    title: '売上ダッシュボード',
    desc: 'チケット売上・手数料・投げ銭をひとつの画面で確認。CSVダウンロードにも対応。',
  },
  {
    icon: <img src="/icons/key.svg" alt="安心の決済インフラ" style={{width: '1.2em', height: '1.2em'}} />,
    title: '安心の決済インフラ',
    desc: 'Stripe を採用した堅牢な決済システム。クレジットカード情報は一切サーバーに保存しません。',
  },
];

const STEPS = [
  { step: '01', title: '主催者登録', desc: 'メールアドレスで無料アカウント作成。審査後すぐに販売開始できます。' },
  { step: '02', title: 'イベントを作成', desc: '日程・会場・チケット価格を入力。公開前に下書き保存でじっくり準備。' },
  { step: '03', title: 'チケット販売開始', desc: 'イベントURLを拡散するだけ。SNSへの共有も簡単です。' },
  { step: '04', title: '売上・投げ銭を受取', desc: 'イベント終了後に振込。' },
];

export default function LandingPage() {
  const [openFaq, setOpenFaq] = useState(null);

  return (
    <div className={styles.page}>

      {/* ─── HERO ─── */}
      <section className={styles.hero}>
        <div className={styles.heroBg} aria-hidden="true" />
        <div className={styles.heroOverlay} aria-hidden="true" />
        <div className={styles.heroInner}>
          <p className={styles.heroEyebrow}>主催者向けチケットプラットフォーム</p>
          <h1 className={styles.heroTitle}>
            音楽イベントを、<br />
            もっと自由に。
          </h1>
          <p className={styles.heroSub}>
            チケット販売・フォトギャラリー・投げ銭。<br />
            イベント主催に必要なすべてが、ここにあります。
          </p>
          <div className={styles.heroActions}>
            <Link className={styles.ctaPrimary} to="/seller-register">無料で始める</Link>
            <a className={styles.ctaSecondary} href="#features">機能を見る</a>
          </div>
        </div>
      </section>

      {/* ─── FEATURES ─── */}
      <section id="features" className={styles.section}>
        <div className={styles.container}>
          <h2 className={styles.sectionTitle}>主催者に選ばれる理由</h2>
          <p className={styles.sectionSub}>必要な機能をシンプルに。余計なものは一切なし。</p>
          <div className={styles.featuresGrid}>
            {FEATURES.map((f) => (
              <article key={f.title} className={styles.featureCard}>
                <div className={styles.featureIcon}>{f.icon}</div>
                <h3 className={styles.featureTitle}>{f.title}</h3>
                <p className={styles.featureDesc}>{f.desc}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* ─── DONATION APPEAL ─── */}
      <section className={`${styles.section} ${styles.donationSection}`}>
        <div className={styles.container}>
          <div className={styles.appealRow}>
            <div className={styles.appealText}>
              <span className={styles.appealBadge}>NEW</span>
              <h2 className={styles.appealTitle}>終演後も、応援は続く</h2>
              <p className={styles.appealDesc}>
                投げ銭機能を有効にすると、イベント終了後もファンがイベントを直接応援できます。
                チケット収益だけに頼らない、新しい収益チャンネルを作りましょう。
              </p>
              <ul className={styles.appealList}>
                <li>✅ イベント終了から最大5日間受付</li>
                <li>✅ 手数料は受取額の15%</li>
                <li>✅ チケット売上と一括で振込</li>
              </ul>
            </div>
            <div className={styles.appealVisual} aria-hidden="true">
              <div className={styles.donationCard}>
                <div className={styles.donationHeart}>💝</div>
                <div className={styles.donationLabel}>投げ銭を送る</div>
                <div className={styles.donationAmounts}>
                  {['¥500', '¥1,000', '¥2,000', '¥5,000'].map((a) => (
                    <span key={a} className={styles.donationAmount}>{a}</span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ─── GALLERY APPEAL ─── */}
      <section className={`${styles.section} ${styles.gallerySection}`}>
        <div className={styles.container}>
          <div className={`${styles.appealRow} ${styles.appealRowReverse}`}>
            <div className={styles.appealText}>
              <h2 className={styles.appealTitle}>思い出を、みんなで作る</h2>
              <p className={styles.appealDesc}>
                フォトギャラリー機能で、イベントの熱量を終演後も発信し続けましょう。
                主催者・参加者どちらからも写真をアップロードでき、ライブの余韻を共有できます。
              </p>
              <ul className={styles.appealList}>
                <li>📸 参加者からの写真投稿を受付</li>
                <li>🎨 アルバム形式でイベントごとに整理</li>
                <li>🔗 SNSシェアで集客にも活用</li>
              </ul>
            </div>
            <div className={styles.appealVisual} aria-hidden="true">
              <div className={styles.galleryMock}>
                <div className={styles.galleryGrid}>
                  {[...Array(6)].map((_, i) => (
                    <div key={i} className={styles.galleryCell} style={{ opacity: 0.4 + i * 0.1 }} />
                  ))}
                </div>
                <div className={styles.galleryLabel}>📚 フォトアルバム</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ─── PRICING ─── */}
      <section className={`${styles.section} ${styles.pricingSection}`}>
        <div className={styles.container}>
          <h2 className={styles.sectionTitle}>シンプルな料金体系</h2>
          <p className={styles.sectionSub}>初期費用・月額費用ゼロ。売れた分だけ手数料が発生します。</p>
          <div className={styles.pricingGrid}>
            <div className={styles.pricingCard}>
              <div className={styles.pricingIcon}>
                <img src="/icons/ticket.svg" alt="チケット販売" style={{width: '1.2em', height: '1.2em'}} />
              </div>
              <div className={styles.pricingName}>チケット販売</div>
              <div className={styles.pricingRate}>最大7<span className={styles.pricingUnit}>%</span></div>
              <div className={styles.pricingNote}>決済手数料込み</div>
            </div>
            <div className={styles.pricingCard}>
              <div className={styles.pricingIcon}>💝</div>
              <div className={styles.pricingName}>投げ銭</div>
              <div className={styles.pricingRate}>15<span className={styles.pricingUnit}>%</span></div>
              <div className={styles.pricingNote}>決済手数料込み</div>
            </div>
            <div className={`${styles.pricingCard} ${styles.pricingFree}`}>
              <div className={styles.pricingIcon}>📸</div>
              <div className={styles.pricingName}>ギャラリー</div>
              <div className={styles.pricingRate}>無料</div>
              <div className={styles.pricingNote}>枚数上限あり（プラン別）</div>
            </div>
          </div>
        </div>
      </section>

      {/* ─── STEPS ─── */}
      <section className={`${styles.section} ${styles.stepsSection}`}>
        <div className={styles.container}>
          <h2 className={styles.sectionTitle}>はじめ方はかんたん4ステップ</h2>
          <div className={styles.steps}>
            {STEPS.map((s, i) => (
              <div key={s.step} className={styles.stepRow}>
                <div className={styles.stepNum}>{s.step}</div>
                {i < STEPS.length - 1 && <div className={styles.stepLine} aria-hidden="true" />}
                <div className={styles.stepContent}>
                  <div className={styles.stepTitle}>{s.title}</div>
                  <div className={styles.stepDesc}>{s.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ─── FAQ ─── */}
      <section className={`${styles.section} ${styles.faqSection}`}>
        <div className={styles.container}>
          <h2 className={styles.sectionTitle}>よくある質問</h2>
          <div className={styles.faqList}>
            {FAQS.map((faq, i) => (
              <div key={i} className={styles.faqItem}>
                <button
                  className={styles.faqQuestion}
                  onClick={() => setOpenFaq(openFaq === i ? null : i)}
                  aria-expanded={openFaq === i}
                >
                  <span>Q. {faq.q}</span>
                  <span className={`${styles.faqChevron} ${openFaq === i ? styles.faqChevronOpen : ''}`}>▼</span>
                </button>
                {openFaq === i && (
                  <div className={styles.faqAnswer}>A. {faq.a}</div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ─── FINAL CTA ─── */}
      <section className={styles.ctaSection}>
        <div className={styles.container}>
          <h2 className={styles.ctaTitle}>さあ、最初のイベントを作ろう</h2>
          <p className={styles.ctaSub}>登録は無料。簡単にチケット販売を開始できます。</p>
          <Link className={styles.ctaPrimary} to="/seller-register">無料で主催者登録</Link>
        </div>
      </section>

    </div>
  );
}
